
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  FaGraduationCap,
  FaBookOpen,
  FaCamera,
  FaUsers,
  FaSearch,
  FaImages,
  FaQuoteLeft,
  FaHeart,
  FaUniversity,
  FaArrowDown,
  FaCheckCircle,
  FaCalendarAlt,
  FaStar,
  FaSignInAlt,
  FaUserCircle,
 FaQrcode,
  FaBookReader,
} from "react-icons/fa";
import { FcGoogle } from "react-icons/fc";
import adssuLogo from "./assets/adssu-logo.png";
import heroBackground from "./assets/hero-background.jpg";
import graduationBackground from "./assets/graduation-background.jpg";
import institutionBackground from "./assets/adssu-institution.jpg";
import gradUet from "./assets/grad-uet.jpg";
import "./LandingPage.css";

const LandingPage = () => {
  const navigate = useNavigate();
const [loginWarning, setLoginWarning] = useState("");
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showFaculty, setShowFaculty] = useState(false);
const [alreadyRegistered, setAlreadyRegistered] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
const [isLoggingIn, setIsLoggingIn] = useState(false);


const [showRegisterModal, setShowRegisterModal] = useState(false);
const [isRegistering, setIsRegistering] = useState(false);
const [registrationMessage, setRegistrationMessage] = useState("");
const [registrationError, setRegistrationError] = useState("");

const [registration, setRegistration] = useState({
  full_name: "",
  email: "",
  role: "student",
  department_program: "",
  position: "",
  batch: "2027",
  batch_name: "Alpas",
});


  const API_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:5000"
    : "https://api.yearbookhub.online";

const handleLogin = async () => {
  if (!email.trim() || !password.trim()) {
    alert("Please enter your email and password.");
    return;
  }

  setIsLoggingIn(true);

  try {
    const res = await axios.post(
  `${API_URL}/login`,
      {
        email: email.trim(),
        password,
      },
      {
        withCredentials: true,
      }
    );

    if (res.data.role === "admin") {
      navigate("/admin");
      return;
    }

    if (res.data.role === "faculty") {
      navigate("/faculty");
      return;
    }

    alert("Your account does not have permission to access this area.");
  } catch (err) {
    console.error("Login error:", err);

    alert(
      err.response?.data?.message ||
        "Invalid email or password."
    );
  } finally {
    setIsLoggingIn(false);
  }
};


const handleRegister = async (e) => {
  e.preventDefault();

  setRegistrationMessage("");
  setRegistrationError("");

  const fullName = registration.full_name.trim();
  const email = registration.email.trim().toLowerCase();

  if (!fullName || !email) {
    setRegistrationError("Please enter your full name and ADSSU email.");
    return;
  }

if (
  registration.role === "student" &&
  (!registration.department_program.trim() ||
    !registration.batch.trim())
) {
  setRegistrationError("Please enter your program and graduating batch.");
  return;
}

if (
  registration.role === "faculty" &&
  (!registration.department_program.trim() ||
    !registration.position.trim())
) {
  setRegistrationError("Please enter your department and position.");
  return;
}

if (
  registration.role === "faculty" &&
  (
    !registration.department_program.trim() ||
    !registration.position.trim()
  )
) {
  setRegistrationError(
    "Please enter your department and position."
  );
  return;
}

setAlreadyRegistered(false);
  setIsRegistering(true);

  try {
    const response = await axios.post(
      `${API_URL}/api/register`,
      {
        ...registration,
        full_name: fullName,
        email,
      },
      { withCredentials: true }
    );

    setRegistrationMessage(response.data.message);
} catch (err) {
  const data = err.response?.data;

  setRegistrationError(
    data?.message || "Registration failed. Please try again."
  );

  setAlreadyRegistered(Boolean(data?.alreadyRegistered));
} finally {
  setIsRegistering(false);
}
};

const openRegister = () => {
  setRegistrationMessage("");
  setRegistrationError("");
  setShowRegisterModal(true);
};

const closeRegister = () => {
  setShowRegisterModal(false);
};


const openLogin = () => {
  setLoginWarning("");
  setShowLoginModal(true);
};

  const closeLogin = () => {
    setShowLoginModal(false);
  };

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({
      behavior: "smooth",
    });
  };

useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const error = params.get("error");

  if (error) {
    let message = "";

    switch (error) {
      case "not_registered":
        message =
          "This ADSSU account is not registered in the Digital Yearbook system. Please contact the administrator.";
        break;

      case "invalid_domain":
        message =
          "Please use your official ADSSU institutional email account.";
        break;

      case "admin_password":
        message =
          "Admin accounts must use email and password login.";
        break;

      case "unauthorized":
        message =
          "Your account is not authorized to use Google login.";
        break;

      case "auth_failed":
      case "server_error":
      default:
        message =
          "We could not sign you in. Please try again.";
        break;
    }

    setLoginWarning(message);
    setShowLoginModal(true);

    // Remove ?error=... from the URL
    window.history.replaceState(
      {},
      document.title,
      window.location.pathname
    );
  }
}, []);

  return (
    <div className="landing-page">    

      {/* =====================================================
          NAVBAR
      ===================================================== */}
      <header className="navbar">

        <div
          className="logo"
          onClick={() => scrollToSection("home")}
        >
<div className="logo-icon-wrapper">
  <img
    src={adssuLogo}
    alt="Agusan del Sur State University Logo"
    className="school-logo"
  />
</div>

          <div className="logo-text">
            <span className="logo-title">ADSSU Digital Yearbook</span>
            
          </div>
        </div>

        <nav className="nav-links">

          <button onClick={() => scrollToSection("about")}>
            About
          </button>

          <button onClick={() => scrollToSection("features")}>
            Features
          </button>

          <button onClick={() => scrollToSection("how-to")}>
  How to Use
</button>

          <button onClick={() => scrollToSection("mission")}>
            Mission & Vision
          </button>

          <button onClick={() => scrollToSection("graduation")}>
            Graduation
          </button>

        </nav>



<div className="navbar-auth-actions">
  <button
    type="button"
    className="login-btn"
    onClick={openLogin}
  >
    Login
  </button>
</div>



      </header>


      {/* =====================================================
          HERO
      ===================================================== */}
      <section
  className="hero-section"
  id="home"
  style={{
    backgroundImage: `url(${heroBackground})`,
  }}
>

        <div className="hero-overlay"></div>

        <div className="hero-content">

          <div className="hero-badge">
            <FaUniversity />
            <span>Agusan del Sur State University</span>
          </div>

          <h1>
            Web-Based
            <span> Interactive Digital Yearbook</span>
          </h1>

          <p>
            Preserve the moments, people, achievements, and memories
            that made your school journey unforgettable.
          </p>

          <div className="hero-buttons">

            <button
              className="yearbook-btn"
              onClick={openLogin}
            >
              <FaBookOpen />
              Explore Yearbook
            </button>

            <button
              className="learn-btn"
              onClick={() => scrollToSection("about")}
            >
              Learn More
            </button>

          </div>

          <div className="hero-stats">

            <div>
              <strong>Class</strong>
              <span>Celebrating Graduates</span>
            </div>

            <div>
              <strong>Digital</strong>
              <span>Yearbook</span>
            </div>

            <div>
              <strong>24/7</strong>
              <span>Accessibility</span>
            </div>

          </div>

        </div>

        <button
          className="scroll-down"
          onClick={() => scrollToSection("about")}
        >
          <FaArrowDown />
        </button>

      </section>


{/* =====================================================
    ABOUT THE YEARBOOK — PREMIUM EDITORIAL DESIGN
===================================================== */}
<section className="about-section" id="about">

  {/* Decorative Elements */}
  <div className="about-decoration about-decoration-one"></div>
  <div className="about-decoration about-decoration-two"></div>

  <div className="section-container">

    {/* =================================================
        HEADER
    ================================================= */}
    <div className="about-header">

      <div className="about-header-label">
        <span className="about-label-line"></span>

        <span>
          ABOUT THE YEARBOOK
        </span>

        <span className="about-label-line"></span>
      </div>

      <h2>
        A Smarter Way to
        <span> Preserve Every Story.</span>
      </h2>

      <p>
        A web-based interactive digital yearbook designed to
        bring together the people, memories, achievements,
        and stories that define the student journey.
      </p>

    </div>


    {/* =================================================
        MAIN EDITORIAL LAYOUT
    ================================================= */}
    <div className="about-editorial-grid">


      {/* =================================================
          LEFT — IMAGE
      ================================================= */}
      <div className="about-visual">

        <div className="about-visual-number">
          01
        </div>

        <div className="about-photo-frame">

          <div
            className="about-photo"
            style={{
              backgroundImage: `url(${gradUet})`,
            }}
          >

            <div className="about-photo-overlay"></div>


            {/* Top Badge */}
            <div className="about-year-badge">

              <FaGraduationCap />

             

            </div>


            {/* Vertical Text */}
            <div className="about-vertical-text">
              ADSSU DIGITAL YEARBOOK
            </div>


            {/* Image Content */}
            <div className="about-photo-content">

              <span>
                AGUSAN DEL SUR STATE UNIVERSITY
              </span>

              <h3>
                Every Chapter.
                <br />
                <strong>Every Memory.</strong>
              </h3>

            </div>

          </div>


          {/* Image Footer */}
          <div className="about-photo-footer">

            <div className="about-photo-footer-text">

              <span>
                DIGITAL YEARBOOK
              </span>

              <strong>
                Memories  People  Achievements
              </strong>

            </div>

            <div className="about-photo-icon">
              <FaBookOpen />
            </div>

          </div>

        </div>


        {/* Floating Decorative Card */}
        <div className="about-floating-card">

          <FaHeart />

          <div>
            <strong>
              Stories That Matter
            </strong>

            <span>
              Preserved digitally
            </span>
          </div>

        </div>

      </div>


      {/* =================================================
          RIGHT — CONTENT
      ================================================= */}
      <div className="about-information">

        {/* Section Number */}
        <div className="about-info-heading">

          <span className="about-info-number">
            01
          </span>

          <span className="about-info-label">
            THE DIGITAL EXPERIENCE
          </span>

        </div>


        <h3>
          A Complete Digital
          <span> Yearbook Experience.</span>
        </h3>


        <p className="about-lead">
          The Web-Based Interactive Digital Yearbook System
          provides a centralized platform for managing
          graduating students, organizing yearbook content,
          and publishing an interactive digital yearbook.
        </p>

        <p>
          The system brings together student and faculty
          profiles, photographs, personal messages, memories,
          and other yearbook content while providing
          administrators with tools for managing themes,
          layouts, approvals, and publication.
        </p>


        {/* =================================================
            FEATURE CARDS
        ================================================= */}
        <div className="about-feature-list">

          <div className="about-feature">

            <div className="about-feature-icon">
              <FaUsers />
            </div>

            <div>
              <strong>
                Centralized Management
              </strong>

              <span>
                Organize profiles, photographs, memories,
                and yearbook content in one platform.
              </span>
            </div>

          </div>


          <div className="about-feature">

            <div className="about-feature-icon">
              <FaBookOpen />
            </div>

            <div>
              <strong>
                Interactive Experience
              </strong>

              <span>
                Explore digital pages, profiles, messages,
                memories, and interactive yearbook content.
              </span>
            </div>

          </div>


          <div className="about-feature">

            <div className="about-feature-icon">
              <FaCamera />
            </div>

            <div>
              <strong>
                Digital Memories
              </strong>

              <span>
                Preserve meaningful photographs, stories,
                achievements, and messages.
              </span>
            </div>

          </div>


          <div className="about-feature">

            <div className="about-feature-icon">
              <FaCheckCircle />
            </div>

            <div>
              <strong>
                Ready for Publication
              </strong>

              <span>
                Compile approved content into an interactive
                flipbook and downloadable PDF.
              </span>
            </div>

          </div>

        </div>


        {/* =================================================
            BOTTOM STATS
        ================================================= */}
        <div className="about-stats">

          <div className="about-stat">

         

              <p>
                Centralized
              </p>
            </div>

      


          <div className="about-stat">

           

              <p>
                Interactive
              </p>
            </div>

    


          <div className="about-stat">

          

              <p>
                Digital
              </p>
            </div>

        

        </div>

      </div>

    </div>

  </div>

</section>



{/* =====================================================
    HOW TO USE
===================================================== */}
<section className="how-to-section" id="how-to">
  <div className="section-container">

    <div className="section-heading centered">
      <span className="section-label">
        HOW TO USE
      </span>

      <h2>
        Your Yearbook,
        <span> Made Simple.</span>
      </h2>

      <p>
        Follow these simple steps to access, personalize,
        and experience the ADSSU Digital Yearbook.
      </p>
    </div>

    <div className="how-to-grid">

      {/* STEP 01 */}
      <div className="how-to-card">
        <div className="how-to-number">01</div>

        <div className="how-to-icon">
          <FaSignInAlt />
        </div>

        <div className="how-to-content">
          <span>STEP 01</span>

          <h3>Sign In with Google</h3>

          <p>
            Students and faculty members sign in using
            their official ADSSU Google account to access
            the yearbook system.
          </p>
        </div>
      </div>


      {/* STEP 02 */}
      <div className="how-to-card">
        <div className="how-to-number">02</div>

        <div className="how-to-icon">
          <FaUserCircle />
        </div>

        <div className="how-to-content">
          <span>STEP 02</span>

          <h3>Update Your Profile</h3>

          <p>
            Students can complete and update their
            yearbook profile with their photo, personal
            information, quote, and other details.
          </p>
        </div>
      </div>


      {/* STEP 03 */}
      <div className="how-to-card">
        <div className="how-to-number">03</div>

        <div className="how-to-icon">
          <FaImages />
        </div>

        <div className="how-to-content">
          <span>STEP 03</span>

          <h3>Submit Your Memories</h3>

          <p>
            Students can submit meaningful photos,
            memories, and special moments to be included
            in the digital yearbook.
          </p>
        </div>
      </div>


      {/* STEP 04 */}
      <div className="how-to-card">
        <div className="how-to-number">04</div>

        <div className="how-to-icon">
          <FaQuoteLeft />
        </div>

        <div className="how-to-content">
          <span>STEP 04</span>

          <h3>Share a Message</h3>

          <p>
            Faculty members can submit messages,
            greetings, and words of encouragement for
            graduating students.
          </p>
        </div>
      </div>


      {/* STEP 05 */}
      <div className="how-to-card">
        <div className="how-to-number">05</div>

        <div className="how-to-icon">
          <FaBookReader />
        </div>

        <div className="how-to-content">
          <span>STEP 05</span>

          <h3>Explore the Yearbook</h3>

          <p>
            Browse student profiles, memories, faculty
            messages, and interactive yearbook pages
            in one digital platform.
          </p>
        </div>
      </div>


      {/* STEP 06 */}
      <div className="how-to-card">
        <div className="how-to-number">06</div>

        <div className="how-to-icon">
          <FaQrcode />
        </div>

        <div className="how-to-content">
          <span>STEP 06</span>

          <h3>Scan the QR Code</h3>

          <p>
            Use a smartphone, tablet, or other device
            to scan a student's QR code and quickly
            access their digital yearbook profile.
          </p>
        </div>
      </div>

    </div>

    <div className="how-to-footer">
      <span></span>

      <p>
        <FaCheckCircle />

        <strong>
          One platform.
        </strong>

        &nbsp; Profiles, memories, messages, and stories preserved digitally.
      </p>

      <span></span>
    </div>

  </div>
</section>



      {/* =====================================================
          GRADUATION
      ===================================================== */}
<section
  className="graduation-section"
  id="graduation"
  style={{
    backgroundImage: `url(${graduationBackground})`,
  }}
>

        <div className="graduation-overlay"></div>

        <div className="graduation-content">

 

          <h2>
            A Chapter Ends.
            <br />
            <span>A New Journey Begins.</span>
          </h2>

          <p>
            Every graduation is a collection of stories -
            friendships formed, challenges overcome,
            lessons learned, and dreams waiting to unfold.
          </p>

          <button
            onClick={openLogin}
            className="graduation-btn"
          >
            <FaBookOpen />
            View the Yearbook
          </button>

        </div>

      </section>



{/* =====================================================
    DIGITAL EXPERIENCE
===================================================== */}
<section
  className="features-section"
  id="features"
>

  <div className="section-container">

    <div className="section-heading centered">

      <span className="section-label">
        DIGITAL EXPERIENCE
      </span>

      <h2>
        Built Around Your
        <span> Yearbook Journey</span>
      </h2>

      <p>
        Experience a modern digital yearbook designed to make
        memories, profiles, photographs, and stories easier to
        manage, explore, and preserve.
      </p>

    </div>

    <div className="features-grid">

      {/* 01 */}
      <div className="feature-card">

        <div className="feature-icon">
          <FaBookOpen />
        </div>

        <h3>Interactive Digital Yearbook</h3>

        <p>
          Explore a complete digital yearbook through interactive
          pages, organized sections, and a flipbook experience
          designed for easy viewing.
        </p>

      </div>


      {/* 02 */}
      <div className="feature-card">

        <div className="feature-icon">
          <FaUsers />
        </div>

        <h3>Student & Faculty Profiles</h3>

        <p>
          View organized profiles containing personal information,
          photographs, quotes, faculty positions, departments,
          and meaningful messages.
        </p>

      </div>


      {/* 03 */}
      <div className="feature-card">

        <div className="feature-icon">
          <FaCamera />
        </div>

        <h3>Smart Photo Management</h3>

        <p>
          Upload individual or multiple photographs with organized
          processing, automatic resizing, cropping, optimization,
          and image enhancement.
        </p>

      </div>


      {/* 04 */}
      <div className="feature-card">

        <div className="feature-icon">
          <FaImages />
        </div>

        <h3>Theme & Layout Studio</h3>

        <p>
          Customize yearbook themes and layouts using a
          Canva-inspired design studio with drag-and-drop editing,
          templates, fonts, and colors.
        </p>

      </div>


      {/* 05 */}
      <div className="feature-card">

        <div className="feature-icon">
          <FaHeart />
        </div>

        <h3>Memories & Social Interaction</h3>

        <p>
          Share memories, posts, messages, comments, and reactions
          that allow students and faculty to participate in a more
          interactive yearbook experience.
        </p>

      </div>


      {/* 06 */}
      <div className="feature-card">

        <div className="feature-icon">
          <FaSearch />
        </div>

        <h3>Organized & Easy Access</h3>

        <p>
          Find and explore yearbook content through organized
          student information, profiles, memories, and other
          digital yearbook sections.
        </p>

      </div>


      {/* 07 */}
      <div className="feature-card">

        <div className="feature-icon">
          <FaCheckCircle />
        </div>

        <h3>Secure Role-Based Access</h3>

        <p>
          Students, faculty, and administrators receive
          role-based access with school email verification and
          protected dashboard features.
        </p>

      </div>


      {/* 08 */}
      <div className="feature-card">

        <div className="feature-icon">
          <FaCalendarAlt />
        </div>

        <h3>Digital Publishing</h3>

        <p>
          After approval, the completed yearbook can be published
          as an interactive flipbook and generated as a
          downloadable PDF copy.
        </p>

      </div>

    </div>

  </div>

</section>




{/* =====================================================
    ABOUT ADSSU — INTRODUCTION
===================================================== */}

<section className="about-introduction">
  <div className="section-container">

    <div className="about-intro-card">

      <div className="about-intro-number">
        01
      </div>

      <div className="about-intro-content">

        <span className="about-section-label">
          ABOUT ADSSU
        </span>

        <h3>
          A Tradition of Service,
          Innovation & Excellence
        </h3>

        <p>
          The Agusan del Sur State University (ADSSU) is a dynamic
          public higher education institution located in the
          municipality of Bunawan, Agusan del Sur. Anchored in a
          long-standing tradition of service and innovation, ADSSU
          continues to play a vital role in the transformation of
          agriculture and technology in Caraga and beyond.
        </p>

        <p>
          ADSSU's roots date back to 1908, when American educators
          established the Manobo Industrial School to uplift the
          lives of Indigenous communities through education.
          Over the decades, the institution evolved through various
          names and mandates from Manobo Farm School to Bunawan
          Agricultural School growing alongside the communities
          it served.
        </p>

        <p>
          It was formally established as a state college through
          Republic Act No. 7932 on March 1, 1995, marking a new
          chapter of accelerated growth, wider academic offerings,
          and deeper community engagement.
        </p>

      </div>

    </div>

  </div>
</section>

{/* =====================================================
    ABOUT ADSSU — HISTORY
===================================================== */}

<section className="about-history">

  <div className="section-container">

    <div className="about-history-header">

      <span className="about-section-label">
        OUR HISTORY
      </span>

      <h3>
        From Our Roots to a
        <span> Global Institution</span>
      </h3>

      <p>
        A journey shaped by education, community service,
        agriculture, innovation, and generations of learners.
      </p>

    </div>

    <div className="history-timeline">

      <div className="history-item">

        <div className="history-year">
          1908
        </div>

        <div className="history-line"></div>

        <div className="history-content">

          <h4>
            The Beginning
          </h4>

          <p>
            American educators established the Manobo Industrial
            School to uplift Indigenous communities through
            education and practical learning.
          </p>

        </div>

      </div>


      <div className="history-item">

        <div className="history-year">
          DEVELOPMENT
        </div>

        <div className="history-line"></div>

        <div className="history-content">

          <h4>
            Growing With the Community
          </h4>

          <p>
            The institution evolved through different names and
            mandates, including Manobo Farm School and Bunawan
            Agricultural School.
          </p>

        </div>

      </div>


      <div className="history-item">

        <div className="history-year">
          1995
        </div>

        <div className="history-line"></div>

        <div className="history-content">

          <h4>
            Becoming a State College
          </h4>

          <p>
            Republic Act No. 7932 formally established the
            institution as a state college on March 1, 1995,
            expanding its academic programs and community
            engagement.
          </p>

        </div>

      </div>


      <div className="history-item history-current">

        <div className="history-year">
          TODAY
        </div>

        <div className="history-line"></div>

        <div className="history-content">

          <h4>
            Agusan del Sur State University
          </h4>

          <p>
            Today, ADSSU continues to advance sustainable
            agriculture, innovation, research, education,
            extension, and community development.
          </p>

        </div>

      </div>

    </div>

  </div>

</section>

{/* =====================================================
    ABOUT ADSSU — TODAY
===================================================== */}

<section className="about-today-section">

  <div className="section-container">

    <div className="about-today">

      <div className="about-today-content">

        <span className="about-section-label">
          ADSSU TODAY
        </span>

        <h3>
          Knowledge.
          <br />
          <span>Innovation.</span>
          <br />
          Sustainable Future.
        </h3>

        <p>
          Today, ADSSU is recognized as a globally-engaged
          institution of sustainable agriculture and innovation,
          actively contributing to national development through
          instruction, research, extension, and resource generation.
        </p>

        <p>
          It champions inclusive access to quality education while
          building strong industry and community partnerships.
        </p>

        <div className="institution-highlight">

          <div className="institution-highlight-icon">
            <FaUniversity />
          </div>

          <div>
            <span className="institution-highlight-label">
              OUR INSTITUTION
            </span>

            <strong>
              Agusan del Sur State University
            </strong>

            <p>
              Celebrating achievements, memories,
              and new beginnings.
            </p>
          </div>

        </div>

      </div>


      <div className="about-today-stats">

        <div className="about-stat">
          <strong>1908</strong>
          <span>
            Roots in community-centered education
          </span>
        </div>

        <div className="about-stat">
          <strong>1995</strong>
          <span>
            Established as a state college
          </span>
        </div>

        <div className="about-stat">
          <strong>ADSSU</strong>
          <span>
            Globally-engaged institution of sustainable
            agriculture and innovation
          </span>
        </div>

      </div>

    </div>

  </div>

</section>


{/* =====================================================
    ADSSU INSTITUTIONAL PROFILE
===================================================== */}

<section
  className="institutional-section"
  id="mission"
  style={{
    backgroundImage: `url(${institutionBackground})`,
  }}
>
  <div className="institutional-overlay"></div>

  <div className="section-container institutional-container">

    {/* ================= HEADER ================= */}
    <div className="institutional-header">
      <div className="institutional-eyebrow">
        <span></span>
        OUR INSTITUTION
        <span></span>
      </div>

      <h2>
        ADSSU <span>Vision, Mission & Goals</span>
      </h2>

      <p>
        Discover the vision, mission, philosophy, and institutional
        goals that guide Agusan del Sur State University.
      </p>
    </div>


    {/* ================= VISION ================= */}
    <div className="institutional-main-card vision-feature">

      <div className="institutional-side-number">
        01
      </div>

      <div className="institutional-icon-box">
        <FaStar />
      </div>

      <div className="institutional-content">
        <span className="institutional-label">
          VISION
        </span>

        <h3>
          The globally-engaged Institution of sustainable
          agriculture and innovation.
        </h3>
      </div>

    </div>


    {/* ================= MISSION ================= */}
    <div className="institutional-main-card mission-feature">

      <div className="institutional-side-number">
        02
      </div>

      <div className="institutional-icon-box">
        <FaUniversity />
      </div>

      <div className="institutional-content">

        <span className="institutional-label">
          MISSION
        </span>

        <h3>
          To serve the humanity, the Institution will:
        </h3>

        <div className="mission-list">

          <div className="mission-item">
            <span>01</span>
            <p>
              Provide quality and inclusive instruction
            </p>
          </div>

          <div className="mission-item">
            <span>02</span>
            <p>
              Further its excellence and values
            </p>
          </div>

          <div className="mission-item">
            <span>03</span>
            <p>
              Undertake vibrant research and innovation
            </p>
          </div>

          <div className="mission-item">
            <span>04</span>
            <p>
              Pursue responsive community services for
              sustainable development
            </p>
          </div>

        </div>

      </div>

    </div>


    {/* ================= PHILOSOPHY ================= */}
    <div className="philosophy-card">

      <div className="philosophy-mark">
        <FaQuoteLeft />
      </div>

      <div className="philosophy-content">

        <span className="institutional-label">
          PHILOSOPHY
        </span>

        <p>
          ADSSU believes that the Higher Education should be
          anchored to the tenets of democracy; be guided by the
          continuing pursuit for relevance and excellence and;
          the mover and catalyst for development.
        </p>

      </div>

    </div>


    {/* ================= GOALS ================= */}
    <div className="goals-section">

      <div className="goals-header">

        <div>
          <span className="institutional-label">
            INSTITUTIONAL GOALS
          </span>

          <h3>
            Building a Sustainable <span>Future</span>
          </h3>
        </div>

        <p>
          ADSSU's goals focus on institutional growth, student
          development, research, innovation, community engagement,
          and sustainable development.
        </p>

      </div>


      <div className="goals-grid">

        <div className="goal-card">
          <span>01</span>
          <p>
            Maximize opportunities to increase institutional
            revenue to sustain growth.
          </p>
        </div>

        <div className="goal-card">
          <span>02</span>
          <p>
            Provide improved delivery of administrative services.
          </p>
        </div>

        <div className="goal-card">
          <span>03</span>
          <p>
            Engage actively with industry partners to complement
            the programs and operations.
          </p>
        </div>

        <div className="goal-card">
          <span>04</span>
          <p>
            Provide comprehensive students services to attain
            holistic student development.
          </p>
        </div>

        <div className="goal-card">
          <span>05</span>
          <p>
            Enhance research, development and innovation
            productivity with social impact and influence.
          </p>
        </div>

        <div className="goal-card">
          <span>06</span>
          <p>
            Strengthen responsive and impactful extension
            activities.
          </p>
        </div>

        <div className="goal-card">
          <span>07</span>
          <p>
            Attain recognition as leading provider for innovative
            and entrepreneurial technology and business solutions
            that will spur economic development.
          </p>
        </div>

        <div className="goal-card">
          <span>08</span>
          <p>
            Accelerate human resource and student development
            contributing to knowledge economy.
          </p>
        </div>

      </div>

    </div>

  </div>
</section>

    

{/* =====================================================
    YOUR JOURNEY
===================================================== */}

<section className="journey-section" id="journey">
  <div className="section-container">

    {/* HEADER */}
    <div className="journey-header">
      <div className="journey-eyebrow">
        <span></span>
        YOUR JOURNEY
        <span></span>
      </div>

      <h2>
        From First Day to
        <span> Graduation Day</span>
      </h2>

      <p>
        Every student journey is made up of moments,
        milestones, friendships, challenges, and achievements
        that become part of a story worth remembering.
      </p>
    </div>

    {/* TIMELINE */}
    <div className="journey-timeline">

      {/* 01 */}
      <div className="journey-item">
        <div className="journey-marker">
          <span>01</span>
        </div>

        <div className="journey-card">
          <div className="journey-card-top">
            <span className="journey-step">CHAPTER 01</span>
            <span className="journey-line"></span>
          </div>

          <h3>Beginning</h3>

          <p>
            The first day marks the beginning of a new
            academic journey filled with opportunities,
            discoveries, and dreams.
          </p>

          <div className="journey-card-footer">
            <span>START</span>
            <span>01</span>
          </div>
        </div>
      </div>

      {/* 02 */}
      <div className="journey-item">
        <div className="journey-marker">
          <span>02</span>
        </div>

        <div className="journey-card">
          <div className="journey-card-top">
            <span className="journey-step">CHAPTER 02</span>
            <span className="journey-line"></span>
          </div>

          <h3>Student Life</h3>

          <p>
            Classes, friendships, organizations, activities,
            challenges, and unforgettable experiences shape
            the years spent at ADSSU.
          </p>

          <div className="journey-card-footer">
            <span>EXPERIENCE</span>
            <span>02</span>
          </div>
        </div>
      </div>

      {/* 03 */}
      <div className="journey-item">
        <div className="journey-marker">
          <span>03</span>
        </div>

        <div className="journey-card">
          <div className="journey-card-top">
            <span className="journey-step">CHAPTER 03</span>
            <span className="journey-line"></span>
          </div>

          <h3>Achievements</h3>

          <p>
            Every accomplishment, milestone, competition,
            project, and success becomes part of a journey
            worth celebrating.
          </p>

          <div className="journey-card-footer">
            <span>ACHIEVE</span>
            <span>03</span>
          </div>
        </div>
      </div>

      {/* 04 */}
      <div className="journey-item journey-item-final">
        <div className="journey-marker">
          <span>04</span>
        </div>

        <div className="journey-card">
          <div className="journey-card-top">
            <span className="journey-step">CHAPTER 04</span>
            <span className="journey-line"></span>
          </div>

          <h3>Graduation</h3>

          <p>
            One chapter comes to an end as a new journey
            begins. The memories, lessons, and friendships
            continue beyond graduation.
          </p>

          <div className="journey-card-footer">
            <span>NEW BEGINNING</span>
            <span>04</span>
          </div>
        </div>
      </div>

    </div>

    {/* BOTTOM MESSAGE */}
    <div className="journey-closing">
      <span className="journey-closing-line"></span>

      <p>
        Four chapters. Countless memories.
        <strong> One unforgettable journey.</strong>
      </p>

      <span className="journey-closing-line"></span>
    </div>

  </div>
</section>


      {/* =====================================================
          LEGACY CTA
      ===================================================== */}
      <section className="legacy-section">

        <div className="legacy-content">

          <FaHeart className="legacy-heart" />

          <span className="section-label">
            YOUR STORY MATTERS
          </span>

          <h2>
            Memories Fade.
            <br />
            <span>Stories Live On.</span>
          </h2>

          <p>
            Let this yearbook become a digital reminder
            of the people, moments, and memories that
            shaped your journey.
          </p>

          <button
            className="legacy-btn"
            onClick={openLogin}
          >
            <FaBookOpen />
            Enter the Yearbook
          </button>

        </div>

      </section>


      {/* =====================================================
          FOOTER
      ===================================================== */}
      <footer className="landing-footer">

        <div className="footer-container">

          <div className="footer-brand">

<div className="footer-logo">
  <img
    src={adssuLogo}
    alt="Agusan del Sur State University Logo"
    className="footer-school-logo"
  />

  <div>
    <strong>ADSSU Digital Yearbook</strong>
    
  </div>
</div>

            <p>
              Preserving memories. Celebrating achievements.
              Connecting generations.
            </p>

          </div>


          <div className="footer-links">

            <h4>Explore</h4>

            <button onClick={() => scrollToSection("about")}>
              About
            </button>

            <button onClick={() => scrollToSection("features")}>
              Features
            </button>

            <button onClick={() => scrollToSection("how-to")}>
  How to Use
</button>

            <button onClick={() => scrollToSection("mission")}>
              Mission & Vision
            </button>

            <button onClick={() => scrollToSection("graduation")}>
              Graduation
            </button>

          </div>


          <div className="footer-links">

            <h4>Yearbook</h4>

            <button onClick={openLogin}>
              Student/faculty Login
            </button>

            <button onClick={openLogin}>
              Admin Login
            </button>

          </div>

        </div>


        <div className="footer-bottom">

          <span>
            @ 2026 Agusan del Sur State University
          </span>

          <span>
            Web-Based Interactive Digital Yearbook System With QR Code Enabled Student Profiles
          </span>

        </div>

      </footer>


{showRegisterModal && (
  <div className="modal-overlay" onClick={closeRegister}>
    <div
      className="modal-box registration-modal"
      onClick={(e) => e.stopPropagation()}
    >
      <button
        type="button"
        className="modal-close"
        onClick={closeRegister}
        aria-label="Close registration"
      >
        ×
      </button>

      <div className="login-header">
        <div className="login-logo">
          <img
            src={adssuLogo}
            alt="ADSSU"
            className="login-school-logo"
          />
        </div>
        <span>ADSSU DIGITAL YEARBOOK</span>
        <h2>Create Your Account</h2>

      </div>

      {registrationError && (
        <div className="registration-error" role="alert">
          {registrationError}
        </div>
      )}

      {alreadyRegistered && (
  <button
    type="button"
    className="login-submit-btn"
    onClick={() => {
      setShowRegisterModal(false);
      setRegistrationError("");
      setAlreadyRegistered(false);
      openLogin();
    }}
  >
    <FcGoogle /> Continue to Google Login
  </button>
)}

      {registrationMessage ? (
        <div className="registration-success" role="status">
          <p>{registrationMessage}</p>
          <button
            type="button"
            className="login-submit-btn"
            onClick={() => {
              setShowRegisterModal(false);
              setRegistrationMessage("");
              setLoginWarning("");
              setShowFaculty(false);
              setShowLoginModal(true);
            }}
          >
            Continue to Google Login
          </button>
        </div>
      ) : (
        <form className="registration-form" onSubmit={handleRegister}>
          <label>
            Registration type
            <select
              value={registration.role}
              onChange={(e) =>
                setRegistration((prev) => ({
                  ...prev,
                  role: e.target.value,
                }))
              }
              required
            >
              <option value="student">Graduating Student</option>
              <option value="faculty">Faculty</option>
            </select>
          </label>

          <label>
            Full name
            <input
              type="text"
              autoComplete="name"
              maxLength={150}
              value={registration.full_name}
              onChange={(e) =>
                setRegistration((prev) => ({
                  ...prev,
                  full_name: e.target.value,
                }))
              }
              required
            />
          </label>

          <label>
            Institutional email account
            <input
              type="email"
              autoComplete="email"
              placeholder="you@adssu.edu.ph"
              value={registration.email}
              onChange={(e) =>
                setRegistration((prev) => ({
                  ...prev,
                  email: e.target.value,
                }))
              }
              required
            />
          </label>

          {registration.role === "student" && (
            <>
              <label>
                Program
                <input
                  type="text"
                  maxLength={100}
                  placeholder="e.g. BSIT"
                  value={registration.department_program}
                  onChange={(e) =>
                    setRegistration((prev) => ({
                      ...prev,
                      department_program: e.target.value,
                    }))
                  }
                  required
                />
              </label>

<div className="batch-details-notice">
  <div className="batch-details-heading">
    <FaGraduationCap />
    <strong>Graduating Batch Information</strong>
  </div>

  <p>
    This registration is for the graduating batch of 2027.
    The graduating year and official batch name are already set
    for this batch, so you do not need to enter them manually.
  </p>

  <div className="batch-details-fields">
    <label>
      Graduating Year
      <input type="text" value="2027" readOnly />
    </label>

    <label>
      Batch Name
      <input type="text" value="Alpas" readOnly />
    </label>
  </div>
</div>

              <p className="registration-note">
                This registration is intended for graduating students.
                Use the Institutional Google account matching your registration.
              </p>
            </>
          )}

     {registration.role === "faculty" && (
  <>
    <label>
      Department
      <input
        type="text"
        maxLength={100}
        placeholder="Enter your department"
        value={registration.department_program}
        onChange={(e) =>
          setRegistration((prev) => ({
            ...prev,
            department_program: e.target.value,
          }))
        }
        required
      />
    </label>

    <label>
      Position
      <input
        type="text"
        maxLength={100}
        placeholder="e.g. Instructor, Associate Professor"
        value={registration.position}
        onChange={(e) =>
          setRegistration((prev) => ({
            ...prev,
            position: e.target.value,
          }))
        }
        required
      />
    </label>

    <p className="registration-note">
      Use your institutional account 
    </p>
  </>
)}

          <button
            type="submit"
            className="login-submit-btn"
            disabled={isRegistering}
          >
            {isRegistering ? "Checking..." : "Register"}
          </button>
        </form>
      )}
    </div>
  </div>
)}

      {/* =====================================================
          LOGIN MODAL
      ===================================================== */}
      {showLoginModal && (

        <div
          className="modal-overlay"
          onClick={closeLogin}
        >

          <div
            className="modal-box modern-login"
            onClick={(e) => e.stopPropagation()}
          >

            <button
              className="modal-close"
              onClick={closeLogin}
            >
              x
            </button>


<div className="login-header">
  <div className="login-logo">
    <img
      src={adssuLogo}
      alt="Agusan del Sur State University"
      className="login-school-logo"
    />
  </div>

  <span>ADSSU DIGITAL YEARBOOK</span>

  <h2>
    WELCOME
  </h2>

  <p>
    Sign in to access the yearbook.
  </p>
</div>

{loginWarning && (
  <div className="login-warning">
    <div className="login-warning-icon">
      ?
    </div>

    <div className="login-warning-content">
      <strong>Unable to Sign In</strong>
      <p>{loginWarning}</p>
    </div>

    <button
      type="button"
      onClick={() => setLoginWarning("")}
      className="login-warning-close"
      aria-label="Close warning"
    >
      x
    </button>
  </div>
)}


            {/* LOGIN TYPE */}
            <div className="login-type">

              <p>Sign in as:</p>

              <div className="switch-buttons">

                <button
                  className={!showFaculty ? "active" : ""}
                  onClick={() => setShowFaculty(false)}
                >
                  Student / Faculty
                </button>

                <button
                  className={showFaculty ? "active" : ""}
                  onClick={() => setShowFaculty(true)}
                >
                  Admin
                </button>

              </div>

            </div>


            {/* STUDENT LOGIN */}
            {!showFaculty ? (

  <div className="student-login">
<button
  className="google-btn"
  onClick={() => {
    window.location.href = `${API_URL}/auth/google`;
  }}
>
  <FcGoogle className="google-icon" />
  Sign in with Google
</button>

<small className="login-note">
  Only registered ADSSU institutional accounts can access the yearbook.
</small>

  <small>
    Use your institutional account to sign in
  </small>
</div>

            ) : (

              /* FACULTY LOGIN */
              <div className="login-card fade-in">

                <div className="input-group">

                  <input
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) =>
                      setEmail(e.target.value)
                    }
                  />

                </div>


                <div className="input-group">

                  <input
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) =>
                      setPassword(e.target.value)
                    }
                  />

                </div>


<button
  className="login-submit-btn"
  onClick={handleLogin}
  disabled={isLoggingIn}
>
  {isLoggingIn ? (
    <>
      <span className="login-spinner"></span>
      Signing in...
    </>
  ) : (
    "Log In"
  )}
</button>

              </div>

            )}

          </div>

        </div>

      )}

    </div>
  );
};

export default LandingPage;
